import { useContext } from "react";

import { AppStatusContext } from "./AppStatusContext";

export function useAppStatus() {
  return useContext(AppStatusContext);
}
